// Deriva la lista de funcionalidades visibles de un plan a partir de sus
// `limits` + `features`. Compartido por la landing (Landing.jsx) y la página de
// suscripción (SubscriptionSettings.jsx) para que ambas tarjetas muestren
// EXACTAMENTE lo mismo. Las claves i18n viven bajo `landing.plans.features.*`
// (namespace único, reutilizado en ambas páginas).
export function getPlanFeatures(plan, t) {
  const { limits = {}, features = {} } = plan;
  const items = [];

  if (limits.max_companies === -1)      items.push(t("landing.plans.features.unlimitedCompanies"));
  else if (limits.max_companies === 1)  items.push(t("landing.plans.features.oneCompany"));
  else if (limits.max_companies > 1)    items.push(t("landing.plans.features.upToCompanies", { count: limits.max_companies }));

  if (limits.max_accounts === -1)       items.push(t("landing.plans.features.unlimitedAccounts"));
  else if (limits.max_accounts != null) items.push(t("landing.plans.features.accounts", { count: limits.max_accounts }));

  if (limits.max_versions != null) {
    if (limits.max_versions === -1)     items.push(t("landing.plans.features.unlimitedVersions"));
    else if (limits.max_versions > 1)   items.push(t("landing.plans.features.versions", { count: limits.max_versions }));
  }

  if (features.ai_projections) {
    const months = limits.projection_horizon_months;
    items.push(t("landing.plans.features.aiProjections", { months }));
  }
  if (features.bank_sync)               items.push(t("landing.plans.features.bankSync"));
  if (features.auto_fx)                 items.push(t("landing.plans.features.autoFx"));
  if (!features.restrict_to_consolidation_currency) items.push(t("landing.plans.features.multiCurrency"));
  if (features.api_access)              items.push(t("landing.plans.features.apiAccess"));
  if (features.priority_support)        items.push(t("landing.plans.features.prioritySupport"));
  else                                  items.push(t("landing.plans.features.emailSupport"));

  return items;
}
